import { Input, Modal, Spin } from "antd"
import { useDispatch } from "react-redux";
import GenericGrid from "../common/Grid/GenericGrid";
import TableFilter from "src/components/common/TableFilter/TableFilter";
import { Divider } from "@mui/material";
import filterColumns from "./filterColumns";
import { useEffect, useRef, useState } from "react";
import { fetchReplenishmentJobConfigUpdateSummary } from "./action";
import Breadcrumb from "src/components/common/Breadcrumb/Breadcrumb";
import Button from "../common/Button/Button";
import { showErrorNotification, showSuccessNotification } from "src/util/notifications";
import { UpdateReplenishmentPause } from "./saga";
import { useMsal } from "@azure/msal-react";
import { useFeaturePermission } from "src/context/FeaturePermissionContext";
import { FEATURE_NAMES } from "src/util/constants/feature.constants";

export const ReplenishmentJobUpdate = ({ }: any) => {
    const dispatch = useDispatch();
    const hasMounted = useRef(false);
    const { accounts }: any = useMsal();
    const [visibleUpdate, setVisibleUpdate] = useState(false);
    const [visibleUPCUpdate, setVisibleUPCUpdate] = useState(false);
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [saveData, setSaveData] = useState<any>();
    const [saveUPCData, setSaveUPCData] = useState<any>();
    const [upc, setUPC] = useState<string>('');
    const [data, setData] = useState<any>([]);
    const { isReadOnly } = useFeaturePermission(FEATURE_NAMES.ReplenishmentJobConfiguration);
    const updateModal = (record: any) => {
        setVisibleUpdate(true);
        setSaveData(record);
    };
    const saveModal = (record: any) => {
        setVisibleUPCUpdate(true);
        setSaveUPCData(record);
    };

    let filterValues = filterColumns(updateModal);

    useEffect(() => {
        if (hasMounted.current) return;
        hasMounted.current = true;
        dispatch(fetchReplenishmentJobConfigUpdateSummary({}));
    }, []);

    useEffect(() => {

        const upcListString: string = filterValues.data
            .filter((item: any) => item.Category === "EXCLUSION")
            .map((item: any) => item.ExcludedUPCs)
            .join(",");

        setUPC(upcListString);
        setData(filterValues.data.filter((item: any) => item.Category === "JOB"));

    }, [filterValues.data]);

    const handleApiCall = async (apiFunction: Function, payload: any, onSuccess?: Function) => {
        try {
            setConfirmLoading(true);
            const res = await apiFunction(payload);
            if (onSuccess) onSuccess(res);
        } catch (error: any) {
            showErrorNotification(error?.response?.data?.error?.messages?.[0] || "An error occurred");
        } finally {
            setConfirmLoading(false);
        }
    };

    const handleUpdate = async () => {

        const updatedRow = filterValues.updateData.find((item: any) => item.Id === saveData.Id);
        const clonedRow = updatedRow ? { ...updatedRow } : null;
        if (clonedRow) {
            if (clonedRow.StartDate) {
                clonedRow.StartDate = formatDate(clonedRow.StartDate);
            }

            if (clonedRow.EndDate) {
                clonedRow.EndDate = formatDate(clonedRow.EndDate);
            }
        }
        saveData.CreatedBy = accounts[0]?.username;
        const payload = {
            ...saveData,
            ...clonedRow,
        };

        await handleApiCall(UpdateReplenishmentPause, payload, (res: any) => {
            showSuccessNotification(`${res}`);
        });
        setVisibleUpdate(false);
    };

    const handleSave = async () => {
        const payload = {
            Id: 4,
            ReplenishmentType: "Excluded UPC",
            Category: "EXCLUSION",
            ExcludedUPCs: upc,
            CreatedBy: accounts[0]?.username,
        };

        await handleApiCall(UpdateReplenishmentPause, payload, (res: any) => {
            showSuccessNotification(`${res}`);
        });
        setVisibleUPCUpdate(false);
    }

    const formatDate = (date: Date | null | undefined) => {
        const year = date ? date?.getFullYear() : null;
        const month = date ? String(date?.getMonth() + 1).padStart(2, '0') : null;
        const day = date ? String(date?.getDate()).padStart(2, '0') : null;

        return `${year}-${month}-${day}T00:00:00Z`;
    }

    return (
        <>
            <Spin spinning={confirmLoading}>
                <Divider />
                <Breadcrumb>
                    <span>Replenishment Job Configuration Update </span>
                </Breadcrumb>
                <TableFilter>
                    <div className="form align-items-end flex"></div>
                    <div className="d-flex justify-content-end gap-2">
                    </div>
                </TableFilter>
                <label style={{
                    marginBottom: '10px',
                    fontSize: '12px',
                    fontWeight: '800',
                    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
                    textAlign: 'center',
                    padding: '2px 10px',
                    marginTop: '10px',
                }}>
                    Replenishment Pause Job Config
                </label>
                <GenericGrid
                    columns={filterValues.columns}
                    data={data}
                    enableRowSelection={false}
                    rowSelection={[]}
                    columnVisibility={{}}
                    columnPinning={{}}
                    enableColumnOrdering={false}
                    filterDisplayMode="popover"
                    highlightFilterMatch={false}
                    enablePagination={false}
                    enableStickyHeader={true}
                    enableStickyFooter={false}
                    enableColumnPinning={false}
                    enableGlobalFilter={false}
                    isLoading={filterValues.loading}
                    enableEditing={true}
                    hideTotalRows={true}
                    enableBottomToolbar={false}
                    enableTopToolbar={false}
                    muiTableBodyCellProps={{
                        sx: {
                            fontSize: '11px',
                            textAlign: 'center',
                            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
                            padding: '2px 10px'
                        },
                    }}
                    muiTableHeadCellProps={{
                        sx: {
                            fontSize: '10px',
                            fontWeight: '800',
                            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
                            textAlign: 'center',
                            padding: '2px 10px'
                        }
                    }}
                    muiTableBodyRowProps={{
                        sx: {
                            "& td": {
                                padding: "2px 10px",
                            },
                            textAlign: 'center',
                        },
                    }}
                >
                </GenericGrid>
                <label style={{
                    marginBottom: '4px',
                    fontSize: '12px',
                    fontWeight: '800',
                    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
                    textAlign: 'center',
                    padding: '2px 10px',
                    marginTop: '50px',
                }}>
                    Replenishment – Excluded UPCs
                </label>
                <div style={{ display: 'flex', gap: '10px', alignItems: 'center', }}>
                    <label style={{
                        marginBottom: '4px',
                        fontSize: '12px',
                        fontWeight: '800',
                        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
                        textAlign: 'center',
                        padding: '2px 10px',
                        marginTop: '10px',
                    }}>
                        Excluded UPCs
                    </label>
                    <Input
                        placeholder="Excluded UPCs"
                        name="excludedUPC"
                        type="text"
                        value={upc}
                        style={{ width: "300px", marginTop: '10px', }}
                        onChange={(val: any) => {
                            const cleanedValue = val.target.value
                            .split(',')
                            .map((item: string) => item.trim())
                            .join(',');
                          
                          setUPC(cleanedValue);
                        }}
                        allowClear
                    />
                    <style>
                        {`
                    .ant-input-clear-icon {
                        font-size: 20px !important;
                        top: -2% !important;
                        transform: translateY(-1%) !important;
                        line-height: 1 !important;
        }
                `}
                    </style>
                    <Button
                        size="middle"
                        style={{ borderRadius: 6, marginTop: '10px', }}
                        ant-click-animating-without-extra-node="true"
                        hidden={isReadOnly}
                        onClick={saveModal}
                    >
                        {" "}
                        Save
                    </Button>
                </div>
                <Modal
                    title="Update Confirmation"
                    okText="Ok"
                    centered
                    style={{ top: 10 }}
                    open={visibleUpdate}
                    onCancel={() => setVisibleUpdate(false)}
                    footer={
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'flex-end',
                                gap: '12px',
                                marginBottom: '15px'
                            }}
                        >
                            <Button
                                danger
                                size="middle"
                                onClick={() => setVisibleUpdate(false)}
                                style={{ padding: '8px 20px', fontSize: '12px' }}
                            >
                                Cancel
                            </Button>
                            <Button
                                type="primary"
                                size="middle"
                                onClick={handleUpdate}
                                style={{ padding: '8px 24px', fontSize: '12px' }}
                            >
                                Ok
                            </Button>
                        </div>
                    }
                >
                    <div style={{ marginBottom: '-10px' }}>
                        <span>Are you sure you want to pause replenishment?</span>
                    </div>
                </Modal>
                <Modal
                    title="Update Excluded UPCs Confirmation"
                    okText="Ok"
                    centered
                    style={{ top: 10 }}
                    open={visibleUPCUpdate}
                    onCancel={() => setVisibleUPCUpdate(false)}
                    footer={
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'flex-end',
                                gap: '12px',
                                marginBottom: '15px'
                            }}
                        >
                            <Button
                                danger
                                size="middle"
                                onClick={() => setVisibleUPCUpdate(false)}
                                style={{ padding: '8px 20px', fontSize: '12px' }}
                            >
                                Cancel
                            </Button>
                            <Button
                                type="primary"
                                size="middle"
                                onClick={handleSave}
                                style={{ padding: '8px 24px', fontSize: '12px' }}
                            >
                                Ok
                            </Button>
                        </div>
                    }
                >
                    <div style={{ marginBottom: '-10px' }}>
                        <span>Are you sure you want to update replenishment excluded UPCs?</span>
                    </div>
                </Modal>
            </Spin >
        </>
    );
};
